module.exports = __webpack_public_path__ + "static/media/speaker-terrence.50861dd3.jpg";